import { useCallback, useState } from 'react';
import { DeleteFormValues, KBEntity } from '../admin-knowledge-base.type';
import { Form } from 'antd';
import { Types } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.type';

export const useDeleteForm = (actions: Record<Types, (id: string, effective: Date) => void>) => {
    const [isOpen, setIsOpen] = useState(false);
    const [form] = Form.useForm<DeleteFormValues>();
    const [type, setType] = useState<Types>();

    const onSubmit = (values: DeleteFormValues) => {
        const { id, effective } = values;
        const date = effective && effective.startOf('day').toDate();
        actions[type](id, date);
        form.resetFields();
        hide();
    };

    const hide = useCallback(() => {
        setIsOpen(false);
    }, []);

    const show = useCallback((entity: KBEntity) => {
        form.setFieldValue('id', entity.id);
        setType(entity.type);
        setIsOpen(true);
    }, []);

    return {
        isOpen,
        form,
        type,
        show,
        hide,
        onSubmit,
    };
};
